import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion3 from '../../../../ui/images/questions/ela/grade-k1/question-3.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k1/question-5.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k1_1',
    title: 'Which word sounds like “hat”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k1_1_a',
        text: 'hit',
      },
      {
        name: 'grade_k1_1_b',
        text: 'mat',
        correct: true,
      },
      {
        name: 'grade_k1_1_c',
        text: 'hot',
      },
    ],
  },
  {
    name: 'grade_k1_2',
    title: 'Which word rhymes with “cat”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k1_2_a',
        text: 'cap',
      },
      {
        name: 'grade_k1_2_b',
        text: 'cut',
      },
      {
        name: 'grade_k1_2_c',
        text: 'rat',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_3',
    title: 'Which word rhymes with “dog”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k1_3_a',
        text: 'dig',
      },
      {
        name: 'grade_k1_3_b',
        text: 'log',
        correct: true,
      },
      {
        name: 'grade_k1_3_c',
        text: 'big',
      },
    ],
  },
  {
    name: 'grade_k1_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The big brown dog is running very fast through the green field near the tall trees.”',
    sentence: 'What is the dog doing?',
    answers: [
      {
        name: 'grade_k1_4_a',
        text: 'Sleeping',
      },
      {
        name: 'grade_k1_4_b',
        text: 'Running',
        correct: true,
      },
      {
        name: 'grade_k1_4_c',
        text: 'Eating',
      },
    ],
  },
  {
    name: 'grade_k1_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The bright yellow sun is shining high in the blue sky on a warm and sunny day.”',
    sentence: 'What color is the sun?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k1_5_a',
        text: 'Red',
      },
      {
        name: 'grade_k1_5_b',
        text: 'Yellow',
        correct: true,
      },
      {
        name: 'grade_k1_5_c',
        text: 'Blue',
      },
    ],
  },
  {
    name: 'grade_k1_6',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The playful gray cat likes to climb tall trees and jump from branch to branch in the garden.”',
    sentence: 'What does the cat like to do?',
    answers: [
      {
        name: 'grade_k1_6_a',
        text: 'Climb trees',
        correct: true,
      },
      {
        name: 'grade_k1_6_b',
        text: 'Swim in water',
      },
      {
        name: 'grade_k1_6_c',
        text: 'Fly in the sky',
      },
    ],
  },
  {
    name: 'grade_k1_7',
    title: 'Which word should you use to start this sentence?',
    topic: AssessmentTopics.Writing,
    condition: '______ is my favorite color.',
    answers: [
      {
        name: 'grade_k1_7_a',
        text: 'a',
      },
      {
        name: 'grade_k1_7_b',
        text: 'the',
      },
      {
        name: 'grade_k1_7_c',
        text: 'Yellow',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_8',
    title: 'What punctuation mark goes at the end of this sentence?',
    topic: AssessmentTopics.Writing,
    condition: 'I like to play outside',
    answers: [
      {
        name: 'grade_k1_8_a',
        text: 'comma (,)',
      },
      {
        name: 'grade_k1_8_b',
        text: 'question mark (?)',
      },
      {
        name: 'grade_k1_8_c',
        text: 'period (.)',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_9',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k1_9_a',
        text: 'the sun is shining bright.',
      },
      {
        name: 'grade_k1_9_b',
        text: 'The sun is shining bright',
      },
      {
        name: 'grade_k1_9_c',
        text: 'The sun is shining brightly.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_10',
    title: 'John has ¢72 in his wallet. He spent ¢35 to buy a pen. How many cents are left in his wallet?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k1_10_a',
        text: '¢45',
      },
      {
        name: 'grade_k1_10_b',
        text: '¢50',
      },
      {
        name: 'grade_k1_10_c',
        text: '¢30',
      },
      {
        name: 'grade_k1_10_d',
        text: '¢37',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k1_11',
    title: 'Which word is a noun?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k1_11_a',
        text: 'run',
      },
      {
        name: 'grade_k1_11_b',
        text: 'cat',
        correct: true,
      },
      {
        name: 'grade_k1_11_c',
        text: 'happy',
      },
    ],
  },
  {
    name: 'grade_k1_12',
    title: 'Which sentence uses capital letters correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k1_12_a',
        text: 'my mom is nice',
      },
      {
        name: 'grade_k1_12_b',
        text: 'My mom is nice',
        correct: true,
      },
      {
        name: 'grade_k1_12_c',
        text: 'My Mom Is Nice',
      },
    ],
  },
]
